'use client';

import { ReactNode } from 'react';

interface ContentWindowProps {
  children: ReactNode;
  // Optional props for additional customization
  className?: string;
  width?: string;
  height?: string;
  padding?: string;
  variant?: 'default' | 'elevated' | 'minimal';
  fullHeight?: boolean;
}

export default function ContentWindow({ 
  children,
  className = '',
  width = 'w-full',
  height = 'h-auto',
  padding = '',
  variant = 'default',
  fullHeight = false,
}: ContentWindowProps) {
  
  // Define variants with consistent styling
  const variants = {
    default: 'bg-card-bg border-border shadow-elevated',
    elevated: 'bg-card-bg border-border shadow-popup',
    minimal: 'bg-card-bg border-border shadow-soft'
  };
  
  return (
    <div className={`w-full ${fullHeight ? 'h-full flex flex-col' : ''} p-0`}>
      <div 
        className={`
          ${width} 
          ${fullHeight ? 'h-full flex-1' : height} 
          ${padding} 
          ${variants[variant]}
          rounded-2xl 
          border 
          overflow-hidden
          transition-all 
          duration-300 
          ease-in-out
          ${fullHeight ? 'flex flex-col' : ''}
          ${className}
        `}
      >
        {children}
      </div>
    </div>
  );
} 